import { Link, useLocation } from "react-router-dom";
import siteicon from "./img/sitelogo.png";

function Navbar() {
  const { pathname } = useLocation();

  /** Treat `/` as Home (matches App routes). */
  const isActive = (path) => {
    if (path === "/home") return pathname === "/home" || pathname === "/";
    return pathname === path;
  };

  const navClass = (path) =>
    `nav-item nav-link${isActive(path) ? " active" : ""}`;

  return (
    <nav className="navbar navbar-expand-lg bg-white navbar-light sticky-top px-4 px-lg-5">
      <Link to="/home" className="navbar-brand d-flex align-items-center">
        <h1 className="m-0">
          <img src={siteicon} alt="Ebix Insurance logo" />
        </h1>
      </Link>
      <button
        type="button"
        className="navbar-toggler"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav ms-auto bg-light rounded  py-3 py-lg-0">
          <Link to="/home" className={navClass("/home")}>
            Home
          </Link>
          <Link to="/about" className={navClass("/about")}>
            About Us
          </Link>
          <Link to="/services" className={navClass("/services")}>
            Our Services
          </Link>
          <Link to="/partners" className={navClass("/partners")}>
            Our Partners
          </Link>
          <Link to="/training" className={navClass("/training")}>
            Training
          </Link>
          <a
            href="http://crm.ebixinsurance.com"
            className="nav-item nav-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Become a PoSP
          </a>

          <a
            href="http://crm.ebixinsurance.com"
            className="nav-item nav-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get A Quote
          </a>
          <Link to="/contactus" className={navClass("/contactus")}>
            Contact Us
          </Link>
        </div>
      </div>
    </nav>
  );
}
export default Navbar;
